import React from 'react';
import { BrowserRouter, useInRouterContext } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { getRuntimeBasePath } from 'shared/utils/runtimeBasePath';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    },
  },
});

export function AppProviders({ children }: { children: React.ReactNode }) {
  const base = getRuntimeBasePath();
  const inRouter = useInRouterContext();
  return (
    <QueryClientProvider client={queryClient}>
      {inRouter ? children : <BrowserRouter basename={base || '/'} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>{children}</BrowserRouter>}
    </QueryClientProvider>
  );
}

